import { styled } from "stitches.config"

export const OurIngredientsRoot = styled('div', {
    background: '$accent-white',
    textAlign: 'center',
    padding: '48px 16px',
    '@bp3': {
        padding: '72px',
    },
})

export const OurIngredientsContainer = styled('div', {
    maxWidth: '1200px',
    margin: '0 auto',
})

export const SectionTitle = styled('h2', {
    fontFamily: '$display',
    fontSize: '$h2',
    lineHeight: '$h2',
    letterSpacing: '$h2',
    marginBottom: '$7',

    '@bp3': {
        fontSize: '$h1',
        lineHeight: '$h1',
        letterSpacing: '$h1',
        marginBottom: '$7'
    },
})

export const RecipeLabel = styled('h3', {
    fontSize: '$h3',
    lineHeight: '$h3',
    letterSpacing: '$h3',

    '@bp2': {
        fontSize: '$h2',
        lineHeight: '$h2',
        letterSpacing: '$h2',
    }
})

export const IngredientsColumn = styled('div', {
    width: '100%',
    textAlign: 'left',

    '& > div:last-child': {
        marginTop: '$3',
    },

    '@bp3': {
        width: '50%',
    }
})

export const IngredientsFlex = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '48px',

    '@bp3': {
        flexDirection: 'row',
        gap: '170px',
    }
})

export const ButtonWrapper = styled('div', {
    paddingTop: '$6',

    '@bp2': {
        paddingTop: '$10',
    },
})

